import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import { QueueItem } from '@/types/queue';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText } from '@mui/material';
import { FC, useState } from 'react';
import QueueListItemEdit from './QueueListItemEdit';

type QueueListItemProps = {
  queueItem: QueueItem;
  onSave?: (newQueueItem: QueueItem) => void;
  onDelete?: () => void;
};

const QueueListItem: FC<QueueListItemProps> = (props) => {
  const [openEdit, setOpenEdit] = useState(props.queueItem && !props.queueItem.queue);
  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 2 }}>
      {openEdit ? (
        <QueueListItemEdit
          queueItem={props.queueItem}
          onClose={(isEmpty) => {
            setOpenEdit(false);
            if (isEmpty) {
              props.onDelete && props.onDelete();
            }
          }}
          onSave={(newEventState) => {
            props.onSave && props.onSave(newEventState);
          }}
        />
      ) : (
        <>
          <ListItemText primary={props.queueItem.queue} sx={{ flex: 1 }} />
          <ListItemText primary={props.queueItem.description} sx={{ flex: 2 }} />
          <ListItemText sx={{ flex: 1 }}>
            {props.queueItem.messages?.map((messages) => (
              <Box key={`queuelistitem.${messages}`}>
                <code>{messages}</code>
              </Box>
            ))}
          </ListItemText>
          <ListItemText sx={{ flex: 1 }}>
            <code>{props.queueItem.datatype}</code>
          </ListItemText>
          <IconButton tooltip='Edit' onClick={() => setOpenEdit(true)}>
            <EditIcon />
          </IconButton>
          <ConfirmPopover
            text={
              <>
                Delete <code>{props.queueItem.queue}</code>?
              </>
            }
            onConfirm={() => props.onDelete && props.onDelete()}
            skipConfirm={!props.queueItem.queue}
            icon={<ClearIcon />}
          />
        </>
      )}
    </ListItem>
  );
};

export default QueueListItem;
